import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const styles = {
  menuItem: {
    minHeight: 48,
    py: 0.75,
    display: "flex",
    alignItems: "center",
  },
  submenuIcon: {
    fontSize: "1.2rem",
    mr: 1,
  },
};

function ExpandableMenuSection({
  id,
  label,
  icon: IconComponent,
  expanded,
  onToggle,
  disabled,
  children,
}) {
  return (
    <>
      <MenuItem onClick={() => onToggle(id)} disabled={disabled} sx={styles.menuItem}>
        <IconComponent sx={styles.submenuIcon} />
        {label}
        <Box sx={{ ml: "auto" }}>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</Box>
      </MenuItem>
      {expanded && children}
    </>
  );
}

export default ExpandableMenuSection;
